interface SpreadTier {
  maxStdDev: number;
  spread: number;
}

const SPREAD_TIERS: SpreadTier[] = [
  { maxStdDev: 0.3, spread: 0.005 },
  { maxStdDev: 0.45, spread: 0.0095 },
  { maxStdDev: 0.65, spread: 0.012 },
  { maxStdDev: 0.8, spread: 0.0183 },
  { maxStdDev: 0.9, spread: 0.03 },
  { maxStdDev: 1.0, spread: 0.0442 },
  { maxStdDev: 10.0, spread: 0.0728 },
];

export function lookupDebtSpread(stdDev: number): number {
  for (const tier of SPREAD_TIERS) {
    if (stdDev <= tier.maxStdDev) {
      return tier.spread;
    }
  }
  return SPREAD_TIERS[SPREAD_TIERS.length - 1].spread;
}
